import {
  SCHEME_INIT_SUCCESS,
  SCHEME_INIT_LOADING,
  SCHEME_INIT_FAIL,
  SCHEME_MENU_SUCCESS,
  SCHEME_MENU_LOADING,
  SCHEME_MENU_FAIL,
  PKGPLAN_MENU_SUCCESS,
  PKGPLAN_MENU_LOADING,
  PKGPLAN_MENU_FAIL,
  PKGRISK_MENU_SUCCESS,
  PKGRISK_MENU_LOADING,
  PKGRISK_MENU_FAIL,
  PKGRISKITEM_MENU_SUCCESS,
  PKGRISKITEM_MENU_LOADING,
  PKGRISKITEM_MENU_FAIL,
  STDRISKTEXT_MENU_SUCCESS,
  STDRISKTEXT_MENU_LOADING,
  STDRISKTEXT_MENU_FAIL,
  STDITEMTEXT_MENU_SUCCESS,
  STDITEMTEXT_MENU_LOADING,
  STDITEMTEXT_MENU_FAIL,
  STDRISKTEXT_SET,
  PKGTARFBEN_MENU_SUCCESS,
  PKGTARFBEN_MENU_LOADING,
  PKGTARFBEN_MENU_FAIL,
  PKGTARFFACT_MENU_SUCCESS,
  PKGTARFFACT_MENU_LOADING,
  PKGTARFFACT_MENU_FAIL,
  FACTORLIST_SET
} from '@/store/types'

export const scheme = {
  [SCHEME_INIT_LOADING](state) {
    state.scheme.init = 0
    state.scheme.initErr = []
    state.scheme.menu = {}
  },
  [SCHEME_INIT_SUCCESS](state, data) {
    state.scheme.init = 1
    state.scheme.initErr = []
    state.scheme.menu = data.menu
  },
  [SCHEME_INIT_FAIL](state, error) {
    state.scheme.init = 2
    state.scheme.initErr = error
    state.scheme.menu = {}
  },
  [SCHEME_MENU_LOADING](state) {
    state.scheme.schemeMenu.init = 0
    state.scheme.schemeMenu.initErr = []
    state.scheme.schemeMenu.menu = {}
  },
  [SCHEME_MENU_SUCCESS](state, data) {
    state.scheme.schemeMenu.init = 1
    state.scheme.schemeMenu.initErr = []
    state.scheme.schemeMenu.sideMenuTitle = data.data.scheme.schemeDesc
    state.scheme.schemeMenu.menu = data.menu
  },
  [SCHEME_MENU_FAIL](state, error) {
    state.scheme.schemeMenu.init = 2
    state.scheme.schemeMenu.initErr = error
    state.scheme.schemeMenu.menu = {}
  },
  [PKGPLAN_MENU_LOADING](state) {
    state.scheme.pkgPlanMenu.init = 0
    state.scheme.pkgPlanMenu.initErr = []
    state.scheme.pkgPlanMenu.menu = {}
  },
  [PKGPLAN_MENU_SUCCESS](state, data) {
    state.scheme.pkgPlanMenu.init = 1
    state.scheme.pkgPlanMenu.initErr = []
    state.scheme.pkgPlanMenu.pkgPlanTitle = data.data.pkgPlan.planDesc
    state.scheme.pkgPlanMenu.menu = data.menu
  },
  [PKGPLAN_MENU_FAIL](state, error) {
    state.scheme.pkgPlanMenu.init = 2
    state.scheme.pkgPlanMenu.initErr = error
    state.scheme.pkgPlanMenu.menu = {}
  },
  [PKGRISK_MENU_LOADING](state) {
    state.scheme.pkgRiskMenu.init = 0
    state.scheme.pkgRiskMenu.initErr = []
    state.scheme.pkgRiskMenu.menu = {}
  },
  [PKGRISK_MENU_SUCCESS](state, data) {
    state.scheme.pkgRiskMenu.init = 1
    state.scheme.pkgRiskMenu.initErr = []
    state.scheme.pkgRiskMenu.pkgRiskTitle = data.data.pkgRisk.riskNo
    state.scheme.pkgRiskMenu.menu = data.menu
  },
  [PKGRISK_MENU_FAIL](state, error) {
    state.scheme.pkgRiskMenu.init = 2
    state.scheme.pkgRiskMenu.initErr = error
    state.scheme.pkgRiskMenu.menu = {}
  },
  [PKGRISKITEM_MENU_LOADING](state) {
    state.scheme.pkgRiskItemMenu.init = 0
    state.scheme.pkgRiskItemMenu.initErr = []
    state.scheme.pkgRiskItemMenu.menu = {}
  },
  [PKGRISKITEM_MENU_SUCCESS](state, data) {
    state.scheme.pkgRiskItemMenu.init = 1
    state.scheme.pkgRiskItemMenu.initErr = []
    state.scheme.pkgRiskItemMenu.pkgRiskItemTitle = data.data.pkgRiskItem.itemNo
    state.scheme.pkgRiskItemMenu.menu = data.menu
  },
  [PKGRISKITEM_MENU_FAIL](state, error) {
    state.scheme.pkgRiskItemMenu.init = 2
    state.scheme.pkgRiskItemMenu.initErr = error
    state.scheme.pkgRiskItemMenu.menu = {}
  },
  [STDRISKTEXT_MENU_LOADING](state) {
    state.scheme.stdRiskTxtMenu.init = 0
    state.scheme.stdRiskTxtMenu.initErr = []
    state.scheme.stdRiskTxtMenu.menu = {}
  },
  [STDRISKTEXT_MENU_SUCCESS](state, data) {
    state.scheme.stdRiskTxtMenu.init = 1
    state.scheme.stdRiskTxtMenu.initErr = []
    state.scheme.stdRiskTxtMenu.stdRiskTxt = data.data.pkgStdRiskTxt.stdRiskTxt
    state.scheme.stdRiskTxtMenu.title = data.data.pkgStdRiskTxt.riskNo
    state.scheme.stdRiskTxtMenu.menu = data.menu
  },
  [STDRISKTEXT_MENU_FAIL](state, error) {
    state.scheme.stdRiskTxtMenu.init = 2
    state.scheme.stdRiskTxtMenu.initErr = error
    state.scheme.stdRiskTxtMenu.menu = {}
  },
  [STDITEMTEXT_MENU_LOADING](state) {
    state.scheme.stdItemTxtMenu.init = 0
    state.scheme.stdItemTxtMenu.initErr = []
    state.scheme.stdItemTxtMenu.menu = {}
  },
  [STDITEMTEXT_MENU_SUCCESS](state, data) {
    state.scheme.stdItemTxtMenu.init = 1
    state.scheme.stdItemTxtMenu.initErr = []
    state.scheme.stdItemTxtMenu.title = data.data.pkgStdItemTxt.itemNo
    state.scheme.stdItemTxtMenu.menu = data.menu
  },
  [STDITEMTEXT_MENU_FAIL](state, error) {
    state.scheme.stdItemTxtMenu.init = 2
    state.scheme.stdItemTxtMenu.initErr = error
    state.scheme.stdItemTxtMenu.menu = {}
  },
  [PKGTARFBEN_MENU_LOADING](state) {
    state.scheme.pkgTarfBenMenu.init = 0
    state.scheme.pkgTarfBenMenu.initErr = []
    state.scheme.pkgTarfBenMenu.menu = {}
  },
  [PKGTARFBEN_MENU_SUCCESS](state, data) {
    state.scheme.pkgTarfBenMenu.init = 1
    state.scheme.pkgTarfBenMenu.initErr = []
    state.scheme.pkgTarfBenMenu.title = data.data.pkgTarfBen.benefit
    state.scheme.pkgTarfBenMenu.menu = data.menu
  },
  [PKGTARFBEN_MENU_FAIL](state, error) {
    state.scheme.pkgTarfBenMenu.init = 2
    state.scheme.pkgTarfBenMenu.initErr = error
    state.scheme.pkgTarfBenMenu.menu = {}
  },
  [PKGTARFFACT_MENU_LOADING](state) {
    state.scheme.pkgTarfFactMenu.init = 0
    state.scheme.pkgTarfFactMenu.initErr = []
    state.scheme.pkgTarfFactMenu.menu = {}
  },
  [PKGTARFFACT_MENU_SUCCESS](state, data) {
    state.scheme.pkgTarfFactMenu.init = 1
    state.scheme.pkgTarfFactMenu.initErr = []
    state.scheme.pkgTarfFactMenu.title = data.data.pkgTarfFact.seqNo
    const factor = {
      fact1: data.data.pkgTarfFact.fact1,
      fact2: data.data.pkgTarfFact.fact2,
      fact3: data.data.pkgTarfFact.fact3,
      fact4: data.data.pkgTarfFact.fact4,
      fact5: data.data.pkgTarfFact.fact5,
      fact6: data.data.pkgTarfFact.fact6
    }
    state.scheme.pkgTarfFactMenu.factor = factor
    state.scheme.pkgTarfFactMenu.menu = data.menu
  },
  [PKGTARFFACT_MENU_FAIL](state, error) {
    state.scheme.pkgTarfFactMenu.init = 2
    state.scheme.pkgTarfFactMenu.initErr = error
    state.scheme.pkgTarfFactMenu.menu = {}
  },
  [STDRISKTEXT_SET](state, text) {
    state.scheme.stdRiskTxtMenu.stdRiskTxt = text
  },
  [FACTORLIST_SET](state, factor) {
    state.scheme.pkgTarfFactMenu.factor = factor
  }
}
